import { RecipeTagWrapper } from '@core';

export class MonoprixRecipeTagWrapper extends RecipeTagWrapper {
  constructor() {
    super(false)
  }

  /**
   * No need to watch anyhting on Monoprix, the basket will not update with new products without a url change
   * @returns DomElement to watch
   */
   getTargetContainer(){
    return null;
   }

  /**
   * @returns the placeholder for the recipe-tags
   */
  tagPlaceholders() {
    const items = document.querySelectorAll('[data-test^="fop-wrapper:"]');
    Array.from(items).forEach(item => {
      if (item.getElementsByClassName('miam-recipe-tag-container').length == 0) { // Don't insert a tag if there is one already
        const tagContainer = document.createRange().createContextualFragment(
          `<div class="miam-recipe-tag-container"><div class="miam-recipe-tag-placeholder"></div></div>`
        );
        item.firstChild.firstChild.children[1].appendChild(tagContainer);
      }
    });
    return document.getElementsByClassName('miam-recipe-tag-placeholder');
  }

  /**
   * @returns the item's extId to pass to the recipe-tags
   */
  itemExtId(placeholder) {
    const link = placeholder.parentElement.parentElement.parentElement.querySelector('[data-synthetics="bop-link"]')
    const result = link?.href.match(/(MPX_[0-9]+)/);
    return result && result[1] || '';
  }
}